export default {
  title: 'Program Status',
  since: 'Reporting since: {sinceDate}',
  description:
    "Monitor the status of your Loyalty Reward Program's connection.",
  disclaimer: {
    failed:
      'Our team has identified an issue with the operation at this location.',
    physical:
      'For more details about the integration status of your Loyalty Rewards Program, please access your {provider} account.',
    online:
      'Your online integration is fully active, and payments made by your members are being accepted within your Loyalty Rewards Program.'
  },
  labelCard: {
    online: 'Online program',
    physical: 'In-Store program'
  },
  subTitleInStore: 'Integrated with {provider}',
  contactUs: 'Contact us for more details.'
};
